// removed by extract-text-webpack-plugin
module.exports = {"wordPicker":"WordPicker__wordPicker___3kFwL","word":"WordPicker__word___2K4wX","disabled":"WordPicker__disabled___315t9","chosen":"WordPicker__chosen___179Xv","addWord":"WordPicker__addWord___3-rIK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/questions/WordPicker.scss
// module id = 261
// module chunks = 1